/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import React from "react";
import { SortDirection } from "@aws-amplify/datastore";
import { Patient } from "../models";
import {
  getOverrideProps,
  useDataStoreBinding,
} from "@aws-amplify/ui-react/internal";
import Ptcardsmall from "./Ptcardsmall";
import { Collection } from "@aws-amplify/ui-react";
export default function PtcardsmallCollection(props) {
  const { items: itemsProp, overrideItems, overrides, ...rest } = props;
  const itemsPagination = { sort: (s) => s.name(SortDirection.ASCENDING) };
  const itemsDataStore = useDataStoreBinding({
    type: "collection",
    model: Patient,
    pagination: itemsPagination,
  }).items;
  const items = itemsProp !== undefined ? itemsProp : itemsDataStore;
  return (
    <Collection
      type="list"
      isSearchable={true}
      isPaginated={true}
      searchPlaceholder="Search..."
      itemsPerPage={20}
      direction="column"
      justifyContent="center"
      items={items || []}
      {...rest}
      {...getOverrideProps(overrides, "PtcardsmallCollection")}
    >
      {(item, index) => (
        <Ptcardsmall
          patient={item}
          margin="0 0 0px 0"
          key={item.id}
          {...(overrideItems && overrideItems({ item, index }))}
        ></Ptcardsmall>
      )}
    </Collection>
  );
}
